export default (that) => [
  {
    exportName: that.$l('INDEX.btn_export_customsclearance') || '导出 清关单',
    templateGroup: 'shipment-customsclearance',
    exportCheckUrl: '/factory/shipmentInfo/packlist/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_manifest') || '导出 舱单',
    templateGroup: 'shipment-manifest',
    exportCheckUrl: '/factory/shipmentInfo/shipmentManifest/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_clp') || '导出 CLP',
    templateGroup: 'shipment-clp',
    exportCheckUrl: '/factory/shipmentInfo/exportClpCheck',
  },
  {
    exportName: that.$l('INDEX.btn_export_shipmentadvice') || '导出 SHIPMENT ADVICE',
    templateGroup: 'shipment-shipmentadvice',
    exportCheckUrl: '/factory/shipmentInfo/shipmentManifest/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_packingdetails') || '导出 装箱明细',
    templateGroup: 'shipment-packingdetails',
    exportCheckUrl: '/factory/shipmentInfo/packlist/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_payment') || '导出 Payment',
    templateGroup: 'shipment-payment',
    exportCheckUrl: '/factory/shipmentInfo/packlist/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_containercheck') || '导出 集装箱检查文件',
    templateGroup: 'shipment-containercheck',
    exportCheckUrl: '/factory/shipmentInfo/exportContainerCheckCheck',
  },
  {
    exportName: that.$l('INDEX.btn_export_clrform') || '导出 CLR form',
    templateGroup: 'shipment-clrform',
    exportCheckUrl: '/factory/shipmentInfo/exportClrFormCheck',
  },
  {
    exportName: that.$l('INDEX.btn_export_siformat') || '导出 SI format',
    templateGroup: 'shipment-siformat',
    exportCheckUrl: '/factory/shipmentInfo/exportSIFormatCheck',
  },
  {
    exportName: that.$l('INDEX.btn_export_tc') || '导出 TC 文件',
    templateGroup: 'shipment-tc',
    exportCheckUrl: '/factory/shipmentInfo/exportTCCheck',
  },
  {
    exportName: that.$l('INDEX.btn_bl_manifest') || '导出 截单资料',
    templateGroup: 'lidl-bill-manifest-group',
    exportCheckUrl: '/factory/shipmentInfo/exportManifestCheck',
  },
  {
    exportName: that.$l('INDEX.btn_ship_detail') || '导出 走货明细',
    templateGroup: 'shipment-shipDetail',
    exportCheckUrl: '/factory/shipmentInfo/packlist/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_container_inspection') || '导出 Container Inspection文件',
    templateGroup: 'factory-container-inspection',
    exportCheckUrl: '/factory/shipmentInfo/packlist/checkData',
  }
]
